<template>
  <b-container fluid>
    <b-row>
      <b-col  style="height:20px;padding:0px;">
        <label  v-if="nValue">{{placeholder}}</label>
      </b-col>
    </b-row>
    <b-row>
      <b-col style="padding:0px;">
        <div class="input_conainer" style="position:relative">
          <font-awesome-icon v-if="icon" :icon="icon" style="position:absolute;top:8px;left:0px;" :style="{color: getCssColor('primary_bt')}"/>
          <input :maxLength="maxLength" :type="type" @keyup.enter="$emit('inputEnter')" :style="{paddingLeft:(icon ? '30px' : '')}" v-model="nValue" class="new_input_text" autocapitalize="none" :placeholder="placeholder" :disabled="disabled"/>
        </div>
      </b-col>
    </b-row>
    <b-row>
      <b-col style="padding:0px;">
        <label v-if="required">Campo Obrigatório</label>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import colors from '@/mixins/colors'

export default {
  props: [
    'type',
    'required',
    'value',
    'placeholder',
    'disabled',
    'icon',
    'maxLength'
  ],

  data () {
    return {
      nValue: this.value
    }
  },

  mixins: [colors],

  watch: {
    value (val) {
      this.nValue = val
    },

    nValue(val) {
      this.$emit('input', val)
    }
  }

}
</script>

<style lang="scss">

@import "@/css/_variables.scss";

.input_conainer{
  border-bottom:1px solid #969696;
}

.input_conainer:focus-within {
  border-bottom:2px solid  rgb(239, 157, 33);
}


.new_input_text {
  border:0;
  font-size: 17px;
  line-height: 20px;
  height:30px;
  width:100%;
}

.new_input_text:FOCUS{
  outline: none;
  border:0;
  text-decoration:none;
}

label {
  font-size: 12px;
  line-height: 16px;

  color: #969696;
}

input:disabled {
  color: #afaeae;
}
</style>
